import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { librarySettingsAPI } from '@/providers/apis/library/library';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'other-library-ids',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class OtherLibraryIds extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop()
    private value: any;

    @Prop()
    private isReadOnly: any;

    private isExpand: boolean = false;

    private updatedValues: any = {};

    private libComponent: any = {
        otherLibraryIds: {
            name: 'Other library id',
            parentKey: null,
            keyName: 'other_library_ids',
            required: {},
            items: [],
            fieldType: 'b-form-select',
            options: {
                'text-field': 'name',
                'value-field': 'id',
                'options': [],
            },
        },
    };

    private otherLibraryIds: any = [];

    private libraryIdsString: any = '';

    // ---------------------------------------------------------------------
    // Methods

    private created() {
        if (this.value && this.value.other_library_ids) {
            this.otherLibraryIds = this.value.other_library_ids;
        }
        let dataString = '';
        librarySettingsAPI.fetchLibraryItemList().then((data: any) => {
            this.libComponent.otherLibraryIds.options.options = data;
            if (this.otherLibraryIds && this.otherLibraryIds.length > 0) {
                for (const iterator of this.otherLibraryIds) {
                    const libData = data.find((item: any) => {
                        return item.id === iterator;
                    });
                    dataString += `${libData.name} ; `;
                }
            }
            this.libraryIdsString = dataString;
        });
    }

    private onChangeConfig(item: any) {
        this.$emit('input', this.updatedValues);
    }

}
